const config = {
	debug: {
		host: 'pastease.mopinion.com',
	},
	host: 'deploy.mopinion.com',
	deployments: {},
};

let listeners = [];

function onConfigChange(fn) {
	listeners.push(fn);
	return listeners.filter(listener => listener !== fn);
}

function setConfig(fn = () => {}) {
	const newConfig = fn(config);
	if (newConfig) {
		Object.assign(config, newConfig);
		listeners.forEach(f => f(config));
	}
}

function getConfig(fn = () => {}) {
	return fn(config);
}

function getDeployDomain(id) {
	return getConfig(config => {
		if (config.proxyDeployDomain) {
			return config.proxyDeployDomain;
		}
		if (config.debug[id]?.enabled) {
			return config.debug.host;
		}
		return config.host;
	});
}

function getDebugDomain() {
	return getConfig(config => {
		if (config.proxyDebugDomain) {
			return config.proxyDebugDomain;
		}
		if (config.proxyDeployDomain) {
			return config.proxyDeployDomain;
		}
		return config.debug.host;
	});
}

function getDebugEnabled(id = '') {
	return getConfig(config => config.debug[id]?.enabled);
}

function setDebugEnabled(id = '', enabled = true) {
	setConfig(config => {
		if (!config.debug[id]) {
			config.debug[id] = {};
		}
		config.debug[id].enabled = enabled;
	});
}

function getDebugVersion(id = '') {
	return getConfig(config => config.debug[id]?.revision ?? 'live');
}

function setDebugVersion(id = '', revision = 'live') {
	setConfig(config => {
		if (!config.debug[id]) {
			config.debug[id] = {};
		}
		config.debug[id].revision = revision;
	});
}

export {
	config,
	setConfig,
	getConfig,
	onConfigChange,
	getDeployDomain,
	getDebugDomain,
	getDebugEnabled,
	setDebugEnabled,
	getDebugVersion,
	setDebugVersion,
};
